import { createReducer, on, Action } from '@ngrx/store';
import * as UserActions from '../actions/user.action';
import { IUserState, initialUserState } from '../state/user.state';

export const userReducer = createReducer(
    initialUserState,
    on(UserActions.loginAction, (state: any) => {
        return ({
            ...state,
        })
    }),
    on(UserActions.logoutAction, (state: any) => {
        return ({
            ...state,
        })
    }),

);

export function userReducers(state: IUserState, action: Action) {
    return userReducer(state, action);
}
